import * as Yup from 'yup';

export const Loginschema = Yup.object().shape({
    phoneNum : Yup.string()
    .matches(/^[0-9]+$/, "That doesn't look like a phone number")
    .min(8, "A phone number must be at least 8 digits")
    .required('A phone number is required'),
    password : Yup.string().min(4).max(50).required("*required")
});



